import { render, staticRenderFns } from "./ActiveCategory.vue?vue&type=template&id=04e7cc4c&scoped=true&"
import script from "./ActiveCategory.vue?vue&type=script&lang=js&"
export * from "./ActiveCategory.vue?vue&type=script&lang=js&"
import style0 from "./ActiveCategory.vue?vue&type=style&index=0&id=04e7cc4c&prod&lang=scss&scoped=true&"
import style1 from "./ActiveCategory.vue?vue&type=style&index=1&id=04e7cc4c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e7cc4c",
  null
  
)

export default component.exports